const authHeader = () => {
  const user = JSON.parse(localStorage.getItem('infoBookingUser'));

  if (user && user.accessToken) {
    return { Authorization: `Bearer ${user.accessToken}` };
  }
  return {};
};

const activeSiteHeader = () => {
  const activeSite =
    sessionStorage.getItem('activeSite') ?? localStorage.getItem('activeSite');
  const [siteId] = activeSite?.split(';') || [];

  return {
    'X-Active-Site': siteId,
  };
};

const csrfHeader = () => {
  return {
    'X-CSRF':
      'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855',
  };
};

const apiRequestHeaders = {
  authHeader,
  csrfHeader,
  activeSiteHeader,
};

export default apiRequestHeaders;
